import { render, staticRenderFns } from "./OcrFieldMap.vue?vue&type=template&id=0c497398&"
import script from "./OcrFieldMap.vue?vue&type=script&lang=js&"
export * from "./OcrFieldMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports